export default {
  getPaymentTypes: state => state.paymentTypes || [],
};
